import { ProductListItem } from "./product_list_item";

export const ProductList = (props) => {
  let products = props.products.map((product, i) => (
    <ProductListItem
      product={product}
      key={product.pr_id}
      category={props.category}
      addToCategorySelection={props.addToCategorySelection}
      removeFromCategorySelection={props.removeFromCategorySelection}
      selectedCategoryItemsIds={props.selectedCategoryItemsIds}
      removeImageUrl={props.removeImageUrl}
      productAddingInProgress={props.productAddingInProgress}
    />
  ));

  return (
    <ul className="cleaner product-list-lower">
      {props.products.length > 0 ? (
        products
      ) : (
        <div style={{ textAlign: "center" }}>
          <em>
            Zadaným podmínkám bohužel nevyhovuje žádný produkt. Zkuste podmínky
            upravit a zadat ty opravdu důležité.
          </em>
        </div>
      )}
    </ul>
  );
};
